import * as types from "../constants/actionConstants";

const initialState = {
    template: {
        id: "",
        name: "",
        trackable: false
    },
    questionKeys: [],
    options: {
        validate: [],
        isValidating: false
    }
};

export default function tagEditorReducer(state = initialState, action) {
    let addQuestion;
    switch (action.type) {
        case types.TAG_EDITOR_INITIALIZE: { // Use block scope for constants
            console.log('[Reducer] Before TAG_EDITOR_INITIALIZE:', state);
            const payload = action.payload || {};
            const sourceTemplate = payload.template || initialState.template;
            const sourceKeys = payload.questionKeys || [];
            const sourceOptions = payload.options || {};

            // Create a completely new state object
            const newState = {
                ...state, // Copy existing state properties
                template: { // Create a new template object
                    ...initialState.template, // Start with defaults
                    id: sourceTemplate.id || initialState.template.id,
                    name: sourceTemplate.name || initialState.template.name,
                    trackable: sourceTemplate.trackable !== undefined ? sourceTemplate.trackable : initialState.template.trackable,
                    // Add any other fields explicitly if needed
                },
                questionKeys: [...sourceKeys], // Create a new array for keys
                options: { // Create a new options object
                    ...state.options,
                    ...sourceOptions
                }
            };
            console.log('[Reducer] After TAG_EDITOR_INITIALIZE:', newState);
            return newState;
        }

        case types.TAG_EDITOR_UPDATE:

            let obj = {
                ...state,
                template: {
                    ...state.template,
                    ...action.payload.template
                },
                questionKeys: action.payload.template.questionKeys === undefined ? [] : action.payload.template.questionKeys,
                options: {
                    ...state.options,
                    ...action.payload.options
                }
            };
            return obj;

        case types.TAG_EDITOR_CLEAR:
            return {
                ...initialState
            };


        case types.TAG_EDITOR_ADD_QUESTION:// eslint-disable-line no-case-declarations

            addQuestion = [
                ...state.questionKeys,
                action.question
            ];
            return {
                ...state,
                questionKeys: addQuestion
            };

        case types.TAG_EDITOR_REMOVE_QUESTION:// eslint-disable-line no-case-declarations

            let removeQuestion = state.questionKeys.filter((element, index) => {
                return index !== action.index;
            });
            return {
                ...state,
                questionKeys: removeQuestion
            };


        case types.TAG_EDITOR_NAME_EXISTS:
            return {
                ...state,
                options: {
                    ...state.options,
                    validate: action.list,
                    isValidating: false
                }
            };

        case types.TAG_EDITOR_NAME_VALIDATING:
            return {
                ...state,
                options: {
                    ...state.options,
                    isValidating: true
                }
            };

        default:
            return state;
    }
}
